/** A customer's own page gives each tab its own route, `/customers/:id/<tab>` (`recordTabRoutes`). */
export const CUSTOMER_TABS = ['details', 'restrictions', 'finance', 'promises', 'history'] as const;
export type CustomerTab = (typeof CUSTOMER_TABS)[number];

export const CUSTOMER_TAB_LABELS: Record<CustomerTab, string> = {
  details: 'Details',
  restrictions: 'Restrictions',
  finance: 'Finance',
  promises: 'Promises to pay',
  history: 'History',
};

export function customerPath(id: string): string {
  return `/customers/${id}`;
}

export function customerTabPath(id: string, tab: CustomerTab): string {
  return `${customerPath(id)}/${tab}`;
}

/** The tabs that need `billing.view`: the follow-up log and the promises to pay. */
export function isFinanceTab(tab: CustomerTab): boolean {
  return tab === 'finance' || tab === 'promises';
}
